/**
 * Lightweight scratch-card visual for Games catalog and Dashboard campaign cards.
 * Decorative only — shows partial “scratch” + fake reward to communicate gameplay.
 */
import "./ScratchGamePreview.css";

export type ScratchPreviewTheme = "foil" | "silver" | "gold";

/** Read theme from variant.config (scratch editor) — defaults to foil. */
export function resolveScratchPreviewTheme(config: unknown): ScratchPreviewTheme {
  if (!config || typeof config !== "object" || Array.isArray(config)) return "foil";
  const t = (config as { theme?: unknown }).theme;
  if (t === "silver" || t === "gold") return t;
  return "foil";
}

export interface ScratchGamePreviewProps {
  /** Tighter layout for dashboard thumbnails */
  compact?: boolean;
  /** Visual variant — matches scratch runtime themes */
  theme?: ScratchPreviewTheme;
}

export function ScratchGamePreview({ compact = false, theme = "foil" }: ScratchGamePreviewProps) {
  return (
    <div
      className={
        compact
          ? "scratch-game-preview scratch-game-preview--compact"
          : "scratch-game-preview"
      }
      data-theme={theme}
      aria-hidden
    >
      <div className="scratch-game-preview__card">
        <span className="scratch-game-preview__badge">Instant win</span>

        <div className="scratch-game-preview__playfield">
          <div className="scratch-game-preview__reward" aria-hidden>
            10% OFF
          </div>

          <div className="scratch-game-preview__scratch-overlay" aria-hidden>
            <span className="scratch-game-preview__scratch-grain" />
          </div>

          <p className="scratch-game-preview__hint">Scratch to reveal</p>
        </div>
      </div>
    </div>
  );
}
